function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.66177 10.8571V10.8571C7.75874 10.8571 6.21582 9.322 6.21582 7.42857V7.42857C6.21582 5.53514 7.75874 4 9.66177 4V4C11.5648 4 13.1077 5.53514 13.1077 7.42857V7.42857C13.1077 9.322 11.5648 10.8571 9.66177 10.8571Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4764 36.0005H7.30743L6.44595 27.5609L3 26.717V17.4334C3 15.5691 4.54292 14.0576 6.44595 14.0576H13.3378C15.2409 14.0576 16.7838 15.5691 16.7838 17.4334V26.717L13.3378 27.5609L12.4764 36.0005Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.4997 10.8571V10.8571C26.5966 10.8571 25.0537 9.322 25.0537 7.42857V7.42857C25.0537 5.53514 26.5966 4 28.4997 4V4C30.4027 4 31.9456 5.53514 31.9456 7.42857V7.42857C31.9456 9.322 30.4027 10.8571 28.4997 10.8571Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.05 36.0005H25.95L25.1 29.2488H20L23.9041 15.294C24.1089 14.5631 24.7787 14.0576 25.542 14.0576H31.458C32.2213 14.0576 32.892 14.5631 33.096 15.294L37 29.2488H31.9L31.05 36.0005Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSpouse = function SvgSpouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spouse.9804768e.svg";
export { ForwardRef as ReactComponent };